import { render, staticRenderFns } from "./sendChaBao.vue?vue&type=template&id=0efbb0e2&scoped=true&"
import script from "./sendChaBao.vue?vue&type=script&lang=js&"
export * from "./sendChaBao.vue?vue&type=script&lang=js&"
import style0 from "./sendChaBao.vue?vue&type=style&index=0&id=0efbb0e2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efbb0e2",
  null
  
)

export default component.exports